import { Component, OnInit, ViewChild, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { GridComponent } from '../../core/shared/grid/grid.component';
import { GridMainFilter, GridSelection } from '../../core/shared/grid/grid.model';
import { ProjectsRest } from '../projects.rest';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-project-rows',
  templateUrl: './project-rows.component.html',
  styleUrls: ['./project-rows.component.scss']
})
export class ProjectRowsComponent extends GridSelection implements OnInit, AfterViewInit {

  @Input() customerId: number;
  @Input() initialFilters: {numberString: ''};
  public viewEnable = true;
  public path: string;
  public mainFilter: GridMainFilter[];
  public dialogConfigData: any;

  private headers = [
    // { displayName: 'Numerator', propertyName: 'numberString', propertyType: 'string' },
    // { displayName: 'Nazwa etapu', propertyName: 'projectStepName', propertyType: 'string' },
    { displayName: 'Etap', propertyName: 'projectFullName', propertyType: 'string' },
    { displayName: 'Data rozpoczęcia etapu', propertyName: 'projectStepStartDate', propertyType: 'date', },
    { displayName: 'Data zakończenia etapu', propertyName: 'projectStepEndDate', propertyType: 'date' },
    { displayName: 'Kod kontrahenta', propertyName: 'customerCode', propertyType: 'string' },
    { displayName: 'Opis skrócony', propertyName: 'shortDescription', propertyType: 'string' }
  ];

  constructor(
    private projectRest: ProjectsRest,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super();
    this._grid = this.grid;
  }

  @ViewChild(GridComponent) grid: GridComponent;

  ngOnInit() {
    this.mainFilter = new Array();
    this.setInitialFilters();
    this.path = `api/projectsrows/grid`;
  }

  ngAfterViewInit() {
    this.processDialogConfig();
    this.filter();
  }

  private setInitialFilters() {
    if (this.dialogConfigData != null && this.dialogConfigData['initialFilters']) {
      this.initialFilters = this.dialogConfigData['initialFilters'];
    }
  }

  private setFilter(internalName: string, value: any) {
    this.mainFilter.push({ internalName: internalName, value: value});
    this.grid.mainFilter = this.mainFilter;
  }

  private filter() {
    this.grid.mainFilter = this.mainFilter;
    if (this.customerId != null) {
      this.setFilter('CustomerId', this.customerId);
    }

    this.grid.mainFilter = this.mainFilter;
    this.grid.refreshData();
  }

  private processDialogConfig() {
    if (this.dialogConfigData['customerId']) {
      this.customerId = this.dialogConfigData['customerId'];
    }
  }
}
